export default __webpack_public_path__ + "static/media/Aura-Egg__90.e4dca984.png";